import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_add_email_request_attachment_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { requestId: string, fileContent: Blob, fileName: string, fileType: string, transaction_id?: string }): Promise<{ attachmentId?: string }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.requestId)) {
      missingRequiredInParams.push('\'requestId\'');
    }
    if (isNil(inParams.fileContent)) {
      missingRequiredInParams.push('\'fileContent\'');
    }
    if (isNil(inParams.fileName)) {
      missingRequiredInParams.push('\'fileName\'');
    }
    if (isNil(inParams.fileType)) {
      missingRequiredInParams.push('\'fileType\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/functions/add_email_request_attachment_flow`;
    
    const options = {
    }
    
    url += `?inParams=${encodeURIComponent(JSON.stringify(omit(inParams, ['fileContent'])))}`;
    const body = inParams.fileContent;
    this.utils.http.setBlobHeadersToHttpClientOptions(body, options);
    
    return this.utils.http.post(url, body, options);
    
  }

}

